export function scrollToSection(sectionNumber: number, back?: boolean) {
  const allSections = document.getElementsByTagName("section");
  const targetSection = allSections[sectionNumber];
  targetSection!.style.visibility = "visible";
  const input = targetSection!.getElementsByTagName("input")[0];
  if (input) {
    input.focus();
  }
  setTimeout(
    () => (allSections[back ? sectionNumber + 1 : sectionNumber - 1]!.style.visibility = "hidden"),
    500
  );
  targetSection!.scrollIntoView({ behavior: "smooth", block: "start" });
}
